import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@auth';
import { PreferredOrganizationService } from '@core/services/preferred-organization.service';

/**
 * Full-page block screen (US 27702): "<Entity> is allowed only in your preferred
 * organization". Shown when a sync-cycle page is opened in a server-mode
 * organization. Deliberately has no action button (acceptance criteria) — the
 * body points at the profile-menu switcher.
 */
@Component({
  selector: 'app-blocked-entity',
  templateUrl: './blocked-entity.component.html',
  styleUrls: ['./blocked-entity.component.scss']
})
export class BlockedEntityComponent implements OnInit, OnDestroy {

  entityName = '';
  currentName = '';
  preferredName = '';

  private subscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private authService: AuthService,
    private preferredOrganizationService: PreferredOrganizationService
  ) { }

  ngOnInit(): void {
    // Angular reuses this component when only the query params change (one blocked
    // page to another), so react to every change instead of reading the snapshot once.
    this.subscription = this.route.queryParamMap.subscribe(params => {
      const entityKey = params.get('entity') ?? '';
      const nameKey = `preferredOrg.blockedEntities.${entityKey}`;
      const translated = this.translateService.instant(nameKey);
      this.entityName = translated === nameKey
        ? this.translateService.instant('preferredOrg.blockedEntities.default')
        : translated;

      this.currentName = this.authService.currentOrganization?.name ?? '';
      this.preferredName = this.preferredOrganizationService.preferred?.name ?? '';
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
